import { cn } from '@/lib/utils';

/**
 * Consistent page title component for admin pages
 *
 * @param {string} title - The main title text
 * @param {string} [description] - Optional description below the title
 * @param {React.ReactNode} [icon] - Optional icon component to display before title
 * @param {React.ReactNode} [actions] - Optional action buttons to display on the right
 * @param {string} [className] - Additional classes for the container
 */
const PageTitle = ({ title, description, icon, actions, className }) => {
  return (
    <div className={cn('mb-6', className)}>
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          {icon && (
            <div className="flex-shrink-0 text-amber-600">
              {icon}
            </div>
          )}
          <div className="min-w-0">
            <h1 className="text-2xl font-bold text-stone-800 dark:text-stone-100 truncate">
              {title}
            </h1>
            {description && (
              <p className="text-sm text-stone-600 dark:text-stone-400 mt-0.5 truncate">
                {description}
              </p>
            )}
          </div>
        </div>
        {actions && (
          <div className="flex items-center gap-2 flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageTitle;
